import { formatDistanceToNow } from 'date-fns';

export function relativeTime(iso: string): string {
  return formatDistanceToNow(new Date(iso), { addSuffix: true });
}

export function absoluteTime(iso: string): string {
  return new Date(iso).toLocaleString();
}

export function truncateUrl(url: string, max = 50): string {
  if (url.length <= max) return url;
  return url.slice(0, max - 1) + '…';
}
